/**
 * Adzuki.visual_list
 */

(function VisualList($, Adzuki)
{
	"use strict";

	var $modal          = $('.modal'),
		search_category = '',
		search_string   = '';

	$(document).ready(function documentReady()
	{
		var selected_option;

		if ($('.visual-list').length > 0) {
			VisualList.init();

			$modal.on('change', '#visual-list-category', function searchImagesByCategory(e) {
				var image_category = '';

				// get the selected value
				search_category = $('#visual-list-category').val();

				if (search_category.length) {
					$('.visual-list-item').each(function searchImagesByCategory() {
						image_category = String($(this).data("category-id"));

						if (image_category !== undefined) {
							if (image_category === search_category) {
								$(this).removeClass('hidden');
							} else {
								$(this).addClass('hidden');
							}
						}
					});
				} else {
					$('.visual-list-item').removeClass('hidden');
				}
			});

			$modal.on('keyup', '#visual-list-search', function searchImages(e) {
				var image_name = '';

				if (e.which === 13 ) {
					e.preventDefault();
				} else {
					search_string = $('#visual-list-search').val().toLowerCase();
				}

				if (search_string.length) {
					$('.visual-list-item').each(function searchImages() {
						image_name = $(this).data("name");

						if (image_name !== undefined) {
							image_name = image_name.toLowerCase();

							if (image_name.indexOf(search_string) === -1) {
								$(this).addClass('hidden');
							} else {
								$(this).removeClass('hidden');
							}
						}
					});
				} else {
					$('.visual-list-item').removeClass('hidden');
				}
			});

			$modal.on('click', '.visual-list-container .select-image', function selectImage(e) {
				var $image_id     = $(this).data("id"),
					select_box_id = $(this).data("select"),
					src           = $(this).data("src");

				e.preventDefault();

				$('.visual-list > .active').each(function removeActive() {
					$(this).removeClass('active');
				});

				$(this).parents('.visual-list-item').addClass('active');

				if (src) {
					$('#visual_list_preview').attr('src', src);
					$('#visual_list_preview').removeClass('hidden');
				}

				$modal.modal('hide');

				$('#' + select_box_id).val($image_id);
				$('#' + select_box_id).trigger('change');
			});

			$modal.on('submit', '#visual_list_form', function stopFormSubmit(e) {
				e.preventDefault();
			});
		}

		if ($('.visual-list-selector').length > 0) {
			$('.visual-list-selector').on('change', function visualListSelectboxChanged() {
				var image_src;

				selected_option = $(this).find('option:selected');
				image_src       = selected_option.data('url');

				if (image_src) {
					$('#visual_list_preview').removeClass('hidden');
					$('#visual_list_preview').attr('src', image_src);
				} else {
					$('#visual_list_preview').addClass('hidden');
					$('#visual_list_preview').attr('src', null);
				}
			});
		}
	});

	VisualList.init = function init()
	{
		$('.visual-list').off().on('click', function visualListClicked(e) {
			var $self              = $(this),
				controller         = $self.data('controller'),
				action             = $self.data('action'),
				select_box         = $self.data('select-box'),
				currently_selected = $('#' + select_box).val();

			e.preventDefault();

			Adzuki.Ajax.get('/' + controller + '/' + action + '/' + select_box).then(function success(response) {
				$modal.addClass('wide');
				$modal.find('.modal-title').text('Visual List');
				$modal.find('.modal-body').html(response);

				$('.visual-list-item').each(function highlightBasedOnSelect() {
					if (parseInt($(this).data("id")) === parseInt(currently_selected)) {
						$(this).addClass('active');
					}
				});

				search_string = '';
				$modal.modal('show');
			});
		});
	};

	Adzuki.VisualList = VisualList;
}(jQuery, window.Adzuki || {}));
